import { componentFactory } from 'vue-tsx-support';

import { injectStylesMixin } from '../../../mixins/inject-styles';
import { JtnUiTypography } from '../../jtn-ui-typography';

import styles from './jtn-ui-record-image.styles.scss?module';

export default componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'JtnUiRecordImage',
  components: { JtnUiTypography },
  props: {
    caption: {
      type: String,
      default: ''
    },
    author: {
      type: String,
      default: ''
    },
    isPost: {
      type: Boolean,
      default: false
    },
    displayCaption: {
      type: Boolean,
      default: true
    },
    authorLabel: {
      type: String,
      default: 'Фото'
    }
  },
  computed: {
    hasCaption() {
      return this.displayCaption && (this.caption.length > 0 || this.author.length > 0);
    }
  },
  render() {
    return (
      <figure
        class={[styles.recordImage, this.isPost ? styles.post : '']}
        itemscope
        itemtype="http://schema.org/ImageObject"
      >
        {this.$slots.image}

        {this.hasCaption || this.$slots.share ? (
          <figcaption class={styles.info}>
            {this.caption.length > 0 ? (
              <jtn-ui-typography class={styles.figcaption} tag="p" linkType="link-blue">
                <span itemprop="caption" domPropsInnerHTML={this.caption} />
              </jtn-ui-typography>
            ) : null}

            {this.author.length > 0 || this.$slots.share ? (
              <div
                class={[
                  styles.authorShareWrapper,
                  this.caption.length === 0 ? styles.noCaption : ''
                ]}
              >
                {this.author.length > 0 ? (
                  <jtn-ui-typography
                    class={styles.author}
                    tag="p"
                    type="font-photoday-type-1"
                    linkType="link-blue"
                    itemprop="author"
                    itemscope
                    itemtype="http://schema.org/Person"
                  >
                    {`${this.authorLabel}: `}
                    <span itemprop="name" domPropsInnerHTML={this.author} />
                  </jtn-ui-typography>
                ) : null}

                {this.$slots.share ? (
                  <div class={styles.shareBlock}>{this.$slots.share}</div>
                ) : null}
              </div>
            ) : null}
          </figcaption>
        ) : null}
      </figure>
    );
  }
});
